import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';

const Footer = ({ visible }) => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <Grid container className="footer_area">
        <Grid
          item
          sx={{ width: { xs: '90%', lg: '80%' }, m: 'auto' }}
          className="footer_area_inner"
        >
          <div className="footer_areaL">
            <p>© {currentYear} Quickvee. All rights reserved.</p>
          </div>
          <div className="footer_areaR">
            <ul>
              <li>
                <Link to="/about-us" target="_blank">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" target="_blank">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-condition" target="_blank">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="https://merchantech.com/" target="_blank">
                  Payment Processsing
                </Link>
              </li>
            </ul>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Footer;
